<template>
    <div>
        <div class="table-controls | u-text-right">
            <div class="page-block__header">
                <h1 class="tabulator__title">{{ trans('page.servers.title') }}</h1>
                <button class="btn btn--ghost btn--small" @click="downloadCsv">
                    {{ trans('action.download.csv') }}
                </button>
            </div>
        </div>
        <div class="tabulator">
            <div ref="pagination" class="tabulator-footer"></div>
        </div>
        <div ref="table"></div>

        <sso-modal v-if="ssoModalVisible" :serverId="serverId" @close="closeModal" />
    </div>
</template>

<script>
import Tabulator from 'tabulator-tables';
import SsoModal from './SsoModal.vue';

import '../styles/_tabulator.scss';

export default {
    components: {
        SsoModal
    },
    props: {
        tableData: {
            type: Array,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serverId: null,
            tabulator: null,
            columns: [
                {
                    title: trans('servers.name'),
                    field: 'name',
                    headerFilter: 'input',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: 'filter'
                },
                {
                    title: trans('servers.hostname'),
                    field: 'hostname',
                    headerFilter: 'input',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: 'filter'
                },
                {
                    title: trans('servers.ip_addresses'),
                    field: 'ip_addresses',
                    headerFilter: 'input',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: 'filter'
                },
                {
                    title: trans('servers.websites_header'),
                    field: 'websites',
                    headerFilter: 'input',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: 'filter',
                    width: 120
                },
                {
                    title: trans('servers.customer_login_as_admin'),
                    field: 'customer_login_as_admin',
                    formatter: 'tickCross',
                    formatterParams: {
                        allowEmpty: true,
                        allowTruthy: true,
                        tickElement:
                            '<button class="btn btn--access btn--small">' +
                            trans('page.servers.login_as_admin') +
                            '</button>'
                    },
                    headerFilter: 'select',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: trans('action.filter'),
                    width: 150,
                    cellClick: this.showSsoModal
                }
            ],
            ssoModalVisible: false
        };
    },
    watch: {
        tableData: {
            /**
             * Watcher for the tableData
             *
             * @param {array} newData
             */
            handler(newData) {
                this.tabulator.replaceData(newData);
            },
            deep: true
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.tabulator = new Tabulator(this.$refs.table, {
            ...tabulatorConfig.default,
            paginationElement: this.$refs.pagination,
            columns: this.columns,
            data: this.tableData,
            selectable: false,
            index: 'hostname',
            langs: {
                nl: {
                    pagination: {
                        page_size: trans('pagination.results'),
                        first: trans('pagination.first'),
                        first_title: trans('pagination.first_title'),
                        last: trans('pagination.last'),
                        last_title: trans('pagination.last_title'),
                        prev: trans('pagination.previous'),
                        prev_title: trans('pagination.previous_title'),
                        next: trans('pagination.next'),
                        next_title: trans('pagination.next_title')
                    }
                }
            }
        });

        this.tabulator.setLocale('nl-nl');
    },
    methods: {
        /**
         * Download the contents of the table in CSV format.
         */
        downloadCsv() {
            this.tabulator.download('csv', 'data.csv');
        },
        /**
         * Show the modal to login to the server.
         *
         * @param {object} event
         * @param {object} cell
         */
        showSsoModal(event, cell) {
            this.serverId = cell.getRow().getData().id;
            this.ssoModalVisible = true;
        },
        /**
         * Close the modal.
         */
        closeModal() {
            this.serverId = null;
            this.ssoModalVisible = false;
        }
    }
};
</script>
